"use client";

import React, { FC, useEffect, useState, useRef } from "react";
import Image from "next/image";
import Link from "next/link";
import axios from "axios";
import { Select } from "@headlessui/react";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
interface Props {}

const typeUnit = [
  { id: 3, label: "2 Bedroom", value: "2 Bedroom", active: true },

  { id: 6, label: "Penthouse", value: "Penthouse", active: false },
];

const priceList = [
  { id: 1, label: "Price", value: "price", active: false },
  {
    id: 2,
    label: "21-30 Million Baht",
    value: "21-30 Million Baht",
    active: true,
  },
  {
    id: 3,
    label: "31-40 Million Baht",
    value: "31-40 Million Baht",
    active: true,
  },
  {
    id: 4,
    label: "41-50 Million Baht",
    value: "41-50 Million Baht",
    active: true,
  },
  {
    id: 5,
    label: "more than 50 Million Baht",
    value: "more than 50 Million Baht",
    active: true,
  },
];

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

const RegisterForm: FC<Props> = (): JSX.Element => {
  const ref = useRef(null);
  const [isSending, setIsSending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("2 Bedroom");
  const [price, setPrice] = useState("21-30 Million Baht");
  const [message, setMessage] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  // const recaptchaRef = useRef();
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);

  const saveFile = () => {
    saveAs("/assets/baan_sindhorn_brochure.pdf", "baan_sindhorn_brochure.pdf");
  };

  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token);
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setIsSending(true);

    let URL = process.env.NEXT_PUBLIC_URL + "/api-register/?select=senddata";

    let formData = new FormData();
    formData.append("pkey", String(process.env.NEXT_PUBLIC_P_KEY));
    formData.append("custname", name);
    formData.append("custlastname", lastName);
    formData.append("custemail", email);
    formData.append("custphone", phone);
    formData.append("unit_type", type);
    formData.append("price", price);
    formData.append("message", message);
    formData.append("contacttype", "5");
    formData.append("provider_id", "BSD");
    formData.append("ipaddr", ipAddress);

    if (recaptchaToken) {
      try {
        const response = await axios.post(URL, formData);
        if (response.status == 200) {
          Swal.fire({
            icon: "success",
            title: "Successfully!",
            text: "Your registration has been successful",
            timer: 2000,
            timerProgressBar: true,
          });
          setIsSuccess(true);
          setIsSending(false);
        } else {
          setIsSending(false);
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log("Please complete the reCAPTCHA");
    }
  };

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        if (response.status != 200) {
          throw new Error("Network response was not ok");
        }
        setIpAddress(response.data.ip);
      } catch (error) {
        console.log(error);
      }
    };
    fetchIP();
  }, []);

  return (
    <>
      {!isSuccess ? (
        <div className=" flex flex-col items-center gap-2  py-12 p-6 lg:p-10  rounded-md drop-shadow w-fit ">
          <h1 className="font-semibold text-2xl md:text-4xl font-serif text-white text-center">
            REGISTER
          </h1>
          <p className="text-white font-serif italic text-center font-light">
            Successful registration will entitle to avail of the special
            privileges.
          </p>

          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 lg:grid-cols-2 gap-2 mt-2 max-w-screen-sm "
          >
            <label htmlFor="fName" className="text-white text-sm  gap-1">
              First Name<span className="text-red-600">*</span>
              <input
                type="text"
                id="fName"
                onChange={(e) => setName(e.target.value)}
                required
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none text-sm"
              />
            </label>

            <label htmlFor="lName" className="text-white text-sm gap-1">
              Last Name<span className="text-red-600">*</span>
              <input
                type="text"
                id="lName"
                onChange={(e) => setLastName(e.target.value)}
                required
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none"
              />
            </label>

            <label htmlFor="email" className="text-white text-sm gap-1">
              Email<span className="text-red-600">*</span>
              <input
                type="email"
                id="email"
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none"
              />
            </label>

            <label htmlFor="phone" className="text-white text-sm gap-1">
              Phone<span className="text-red-600">*</span>
              <input
                type="tel"
                id="phone"
                onChange={(e) => setPhone(e.target.value)}
                required
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none"
              />
            </label>

            <label htmlFor="unit" className="text-white text-sm gap-1">
              Type Unit<span className="text-red-600">*</span>
              <Select
                name="unit"
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none text-sm"
                onChange={(e) => setType(e.target.value)}
              >
                {typeUnit.map((item, index) => (
                  <option
                    key={index}
                    value={item.value}
                    disabled={item.active == false}
                    className="!text-black disabled:!text-gray-400 disabled:!text-opacity-50"
                  >
                    {item.label}
                  </option>
                ))}
              </Select>
            </label>

            <label htmlFor="price" className="text-white text-sm gap-1">
              Price<span className="text-red-600">*</span>
              <Select
                name="price"
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none text-sm"
                onChange={(e) => setPrice(e.target.value)}
              >
                {priceList.map((item, index) => (
                  <option
                    key={index}
                    value={item.value}
                    disabled={item.active == false}
                    className="!text-black disabled:!text-gray-400 disabled:!text-opacity-50"
                  >
                    {item.label}
                  </option>
                ))}
              </Select>
            </label>

            <label
              htmlFor="message"
              className="text-white text-sm gap-1 lg:col-span-2"
            >
              Message
              <textarea
                id="message"
                onChange={(e) => setMessage(e.target.value)}
                rows={4}
                className="w-full px-2  py-1 border border-white bg-transparent focus:ring-0 focus:outline-none"
              />
            </label>

            <div className="text-white/75 text-xs flex items-start text-left mt-2 lg:col-span-2 ">
              <label htmlFor="policyCheck">
                <input
                  id="policyCheck"
                  type="checkbox"
                  className="mr-2  accent-[#82603f] -mt-2"
                />
                I have read the
                <Link href="https://siamsindhorn.com/privacy">
                  <span className="text-white px-1 brightness-125">
                    Privacy Policy
                  </span>
                </Link>
                , and hereby give my consent for Siam Sindhorn Co., Ltd. and its
                group companies (&quot;Company&quot;) to collect, use, or
                disclose my Personal Data.
              </label>
            </div>

            <div className="mt-2 lg:col-span-2">
              <ReCAPTCHA
                sitekey="6LfKKHkgAAAAAJvwXdUQhMeN4XlyNQjCLB3coUNU"
                onChange={handleRecaptchaChange}
              />
            </div>

            {!isSending ? (
              <button
                type="submit"
                disabled={recaptchaToken == null}
                className="text-white w-full px-4 py-2 border border-white mt-4 hover:bg-white hover:border-[#82603f] transition duration-200 hover:text-[#82603f] uppercase font-medium lg:col-span-2  disabled:grayscale disabled:opacity-50"
              >
                Submit
              </button>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="text-white w-full flex items-center justify-center mt-4 lg:col-span-2"
                >
                  <g>
                    <circle cx="12" cy="3" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate0"
                        attributeName="r"
                        begin="0;svgSpinners12DotsScaleRotate2.end-0.5s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="16.5" cy="4.21" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate1"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate0.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="7.5" cy="4.21" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate2"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate4.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="19.79" cy="7.5" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate3"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate1.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="4.21" cy="7.5" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate4"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate6.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="21" cy="12" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate5"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate3.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="3" cy="12" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate6"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate8.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="19.79" cy="16.5" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate7"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate5.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="4.21" cy="16.5" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate8"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotatea.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="16.5" cy="19.79" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotate9"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate7.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="7.5" cy="19.79" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotatea"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotateb.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <circle cx="12" cy="21" r="1" fill="currentColor">
                      <animate
                        id="svgSpinners12DotsScaleRotateb"
                        attributeName="r"
                        begin="svgSpinners12DotsScaleRotate9.begin+0.1s"
                        calcMode="spline"
                        dur="0.6s"
                        keySplines=".27,.42,.37,.99;.53,0,.61,.73"
                        values="1;2;1"
                      />
                    </circle>
                    <animateTransform
                      attributeName="transform"
                      dur="6s"
                      repeatCount="indefinite"
                      type="rotate"
                      values="360 12 12;0 12 12"
                    />
                  </g>
                </svg>
              </>
            )}
          </form>
        </div>
      ) : (
        <div className="flex justify-center w-full flex-col items-center">
          <Link href={"/"}>
            <div className="circle-loader load-complete hover:opacity-70 duration-500 cursor-pointer">
              <div className="checkmark draw"></div>
            </div>
          </Link>

          <h1 className="font-bold  text-3xl md:text-4xl font-serif text-white text-center">
            SUCCESS
          </h1>
          <p className="text-white/85 font-serif italic text-center">
            Your registration has been successful
          </p>

          <button
            type="button"
            onClick={saveFile}
            className="text-sm px-4 py-2 text-white shadow btn-grad border uppercase mt-8 inline-flex gap-2 items-center hover:scale-105 transition-all duration-200"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5833 10V17.5833H2.41667V10H0.25V17.5833C0.25 18.775 1.225 19.75 2.41667 19.75H17.5833C18.775 19.75 19.75 18.775 19.75 17.5833V10H17.5833ZM11.0833 10.7258L13.8892 7.93083L15.4167 9.45833L10 14.875L4.58333 9.45833L6.11083 7.93083L8.91667 10.7258V0.25H11.0833V10.7258Z"
                fill="currentColor"
              />
            </svg>
            download brochure
          </button>
        </div>
      )}
    </>
  );
};

export default RegisterForm;
